import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavBar, DataTables, BreadCumb, TimeOut } from '../../components';
import { DISPATCH_ID, SERVICE_RESPONSE } from '../../libs/utils/Const';
import { ApiClient } from '../../libs/apiClient';
import config from '../../config';
import '../../css/responsive.css'
import $ from 'jquery';
import moment from 'moment';
let apiClient = ApiClient.getInstance();

const headersTanque = [
    { title: "Código", value: true },
    { title: "Edificio", value: true },
    { title: "Última Lectura", value: true },
    { title: "Fecha Lectura", value: true },
];
const headersMeter = [
    { title: "Código", value: true },
    { title: "Edificio", value: true },
    { title: "Cliente", value: true },
    { title: "Dirección", value: true },
    { title: "PSI", value: true },
    { title: "Última Lectura", value: true },
    { title: "Fecha Lectura", value: true },
];

class CanalizadosAdminView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')),
            cTab: 0,
            listTanques: [],
            listBuilding: [],
            searchData: {}
        }
    }

    componentDidMount = async () => {
        await this.loadCatalogsTanque();
        await this.searchTanques({
            initDate: moment().format('YYYYMMDD'),
            endDate: moment().format('YYYYMMDD')
        })
    }
    loadCatalogsTanque = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props
        enableSpinner(true)
        let responseAPI = await apiClient.loadCatalogsTanque();
        enableSpinner(false)
        if (responseAPI.status === SERVICE_RESPONSE.SUCCESS) {
            this.setState({
                listBuilding: responseAPI?.data?.listBuilding ?? []
            })
        } else {
            showAlert({ type: 'error', message: responseAPI.message })
        }
    }
    searchTanques = async (search) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props
        enableSpinner(true)
        let responseAPI = await apiClient.listTanques(search);
        enableSpinner(false)
        if (responseAPI.status === SERVICE_RESPONSE.SUCCESS) {
            this.setState({
                listTanques: responseAPI?.data ?? []
            })
        } else {
            showAlert({ type: 'error', message: responseAPI.message })
        }
    }
    UpdateStateField = async (key, value) => {
        await this.setState({ [key]: value });
    }
    refreshSearch = (searchData) => {
        this.setState({
            searchData
        })
    }

    render() {
        const { _user, cTab, listTanques, searchData, listBuilding } = this.state;
        const tabs = [
            {
                title: "Tanques",
                component:
                    <DataTables
                        headers={headersTanque}
                        view={"canalizadoTanque"}
                        data={listTanques}
                        search={this.searchTanques}
                        totalRows={listTanques?.length ?? 0}
                        searchData={searchData}
                        refreshSearch={this.refreshSearch}
                        listBuilding={listBuilding}
                    />,
            },
            {
                title: "Medidores",
                component: <></>
                //  <DataTables
                //     headers={headersMeter}
                //     view={"canalizadoMeter"}
                //      data={[]}
                //     search={()=>{}}
                //     totalRows={0}
                // />
            },

        ];
        return (
            <div className="content">
                <NavBar props={this.props} _user={_user} />
                <TimeOut />
                <BreadCumb subitem1={'CANALIZADOS'} url1={'#'} />
                <div style={{ marginLeft: "4rem", marginBottom: "12rem" }}>
                    <h2 className="md-display-1">
                        <a href=" " id="headmVAdminUser" className="text-muted">
                            &nbsp;CANALIZADOS
                        </a>
                    </h2>
                    <div className="row ml-3">
                        <div className="w-100" >
                            <nav>
                                <div className="nav nav-tabs flex-nowrap flex-md-wrap overflow-auto" id="nav-tab" role="tablist" style={{ WebkitOverflowScrolling: 'touch' }}>
                                    {tabs.map((tab, index) =>
                                        <label
                                            className={`nav-item nav-link font-weight-bold text-secondary text-nowrap ${cTab === index ? 'active' : ''}`}
                                            style={{ cursor: "pointer" }}
                                            onClick={() => this.UpdateStateField('cTab', index)}
                                            key={`tab-${index}`} >
                                            {tab.title}
                                        </label>
                                    )}
                                </div>
                            </nav>

                            <div className="tab-content border border-top-0 rounded-bottom p-2 p-md-3">
                                {tabs.map((tab, index) =>
                                    <div
                                        className={`tab-pane px-1 px-md-3 ${cTab === index ? 'active' : ''}`}
                                        key={`tabpanel-${index}`} >
                                        {cTab === index ? tab.component : ''}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = store => {
    return { notificationReducer: store.NotificationReducer };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value })
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CanalizadosAdminView);
